import { useFormContext } from "@components/forms/useFormContext"
import { AbsentApprovalConfig } from "../../../../../@client/Theasoft_Absences_Config"

export function useUpdateOrCreateApprovalConfigForm() {
  return useFormContext<AbsentApprovalConfig>()
}
